import { render } from "./UserFormModal.vue?vue&type=template&id=fbf05ee6"
import script from "./UserFormModal.vue?vue&type=script&lang=js"
export * from "./UserFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__